import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { CalendarPlanThemeActivities } from '../../../typings';

interface RequestData {
    theme_ids: string[];
}

export function getCalendarPlanThemeActivities(requestData: RequestData): Promise<CalendarPlanThemeActivities[]> {
    const { apiGetCalendarPlanThemeActivities } = apiConfig.getStaticUrls();

    return getFetch(apiGetCalendarPlanThemeActivities, requestData);
}
